module.exports = __webpack_public_path__ + "media/images/category/things-to-do-cba4206867ce4be0ee4812251b1f4626.svg";